import React, { Component } from 'react';
import { withSnackbar } from 'notistack';
import { compose } from 'redux';
import { DialogContent, FormHelperText } from '@mui/material';
import { PubSub, delayedEvent } from '../../utils/eventUtils';

import { deleteState } from '../../states/StateService';
import { withToggleModal } from '../hocs/withToggleModal';

class StateDeleteConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      error: '',
    };
  }

  componentDidMount() {
    const {
      props: { data },
    } = this;

    this.setState({
      id: data.id,
      stateName: data.stateName,
      stateNameAbbrv: data.stateNameAbbrv,
    });
    this.subscription = PubSub.subscribe('foot-button-one', (eventData) => {
      if (eventData) {
        this.handleSubmit();
      }
    });
  }

  handleSubmit = () => {
    PubSub.publish('loading', true);
    PubSub.publish('disabled', true);
    deleteState({
      id: this.state.id,
    })
      .then(() => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        this.props.toggleModal.direct('StateDeleteConfirm', false);
        this.props.enqueueSnackbar('State Deleted Successfully!', {
          variant: 'success',
        });
        delayedEvent('table-refetch', 500, 'states');
      })
      .catch((error) => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        this.setState({ error: error.response.data });
      });
  };

  render() {
    return (
      <DialogContent>
        <div className="modal-title">
          You are about to remove the State -
          <span className="modal-blue-text">
            {this.state.stateName} ({this.state.stateNameAbbrv})
          </span>
          .<p style={{ margin: 0 }}>Are you sure you want to delete it?</p>
        </div>
        <FormHelperText className="api-text-error">
          {this.state.error}
        </FormHelperText>
      </DialogContent>
    );
  }
}

export default compose(withSnackbar, withToggleModal)(StateDeleteConfirm);
